import { isFirstOrganizationUser } from '@/ui/helpers';
import { NavigationGuardNext, Route } from 'vue-router';
import { isOnboardingEnabled } from '@/ui/helpers/featureHelper';
import { user } from '@/ui/auth/auth';
import { NamedLocation } from '@/ui/routes/types';

export function onboardingRedirect(
  to: Route,
  from: Route,
  next: NavigationGuardNext,
): void {
  const isOnboardingNotViewedNorFinished = !user.value.organization.onboardingViewed && !user.value.organization.onboardingFinished;
  const isLoggedIn = user.value.id !== 0;
  const hasSubscription = user.value.subscription !== null;

  const isAllowed = isOnboardingEnabled() && isLoggedIn && isOnboardingNotViewedNorFinished && isFirstOrganizationUser(user.value) && hasSubscription;

  if (isAllowed && from.name !== 'onboarding' && to.name !== 'onboarding') {
    const redirectTo: NamedLocation = { name: 'onboarding' };
    next(redirectTo);

    return;
  }

  next();
}
